import React, { useEffect, useState } from "react";
import ReactDOM from "react-dom/client";

export default function CompareDrawer() {
    const [items, setItems] = useState([]);
    const [message, setMessage] = useState("");

    useEffect(() => {
        function handleCompareToggle(e) {
            const { img, code, checked } = e.detail;
            const normalizedImg = typeof img === "string" && img.trim().length > 0 ? img : null;

            setItems(prev => {
                if (checked) {
                    if (prev.some(p => p.code === code)) return prev;
                    if (prev.length >= 6) {
                        setMessage("You can compare up to 6 items");
                        return prev;
                    }
                    return [...prev, { img: normalizedImg, code }];
                } else {
                    return prev.filter(p => p.code !== code);
                }
            });
        }

        window.addEventListener("compare-toggle", handleCompareToggle);
        return () => window.removeEventListener("compare-toggle", handleCompareToggle);
    }, []);

    function removeItem(code) {
        window.dispatchEvent(
            new CustomEvent("compare-toggle", {
                detail: { code: code, img: null, checked: false },
            })
        );
    }

    function removeAll() {
        items.forEach(item => {
            window.dispatchEvent(
                new CustomEvent("compare-toggle", {
                    detail: { code: item.code, img: null, checked: false },
                })
            );
        });
    }

    const isVisible = items.length > 0;

    const slots = [...items];
    while (slots.length < 6) {
        slots.push(null);
    }

    return (
        <>
        <div className={`compare-drawer ${isVisible ? "" : "hidden"}`}>
            <div className="compare-drawer__wrapper">
                <div className="compare-drawer__wrapper-content">
                    <div className="compare-drawer__header">
                        <h4 className="compare-drawer__header-title">Compare Products</h4>
                        <p className="compare-drawer__header-total">
                            {items.length} of 6 Selected
                        </p>
                        {message && <p className="compare-drawer__error">{message}</p>}
                    </div>

                    <div className="compare-drawer__content">
                        <div className="compare-drawer__items">
                            {slots.map((item, i) =>
                                item ? (
                                    <div key={item.code} className="compare-drawer__item">
                                        {item.img ? (
                                            <img
                                                src={item.img}
                                                alt={item.code}
                                                className="compare-drawer__item-img"
                                            />
                                        ) : null}
                                        <button
                                            className="compare-drawer__remove"
                                            onClick={() => removeItem(item.code)}
                                        >
                                            <img src="/images/close-icon.svg" alt="Remove" />
                                        </button>
                                    </div>
                                ) : (
                                    <div
                                        key={`empty-${i}`}
                                        className="compare-drawer__item empty"
                                    />
                                )
                            )}
                        </div>
                    </div>

                    <div className="compare-drawer__buttons">
                        <button type="button" className="btn" onClick={() => window.compareModal?.open()}>Compare Styles</button>
                        <button type="button" className="btn-secondary" onClick={removeAll}>
                            Remove All
                        </button>
                    </div>
                </div>

                <div className="compare-drawer__buttons-mobile">
                    <button type="button" className="compare-drawer__cta" onClick={() => window.compareModal?.open()}>
                        <img src="/images/arrow-right-white.svg" alt="Compare Styles" />
                    </button>
                    <button
                        type="button"
                        className="compare-drawer__removeall"
                        onClick={removeAll}
                    >
                        Remove All
                    </button>
                </div>
            </div>
        </div>
      
            </>
    );
}

export function initCompareDrawer() {
    const container = document.getElementById("compareDrawerRoot");
    if (!container) return;

    const root = ReactDOM.createRoot(container);
    root.render(<CompareDrawer />);
}
